'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiCancel = function TiCancel(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 6.7c-7.4 0-13.3 6-13.3 13.3s6 13.3 13.3 13.3 13.3-5.9 13.3-13.3-5.9-13.3-13.3-13.3z m-8.3 13.3c0-1.4 0.3-2.7 0.9-3.8l11.2 11.2c-1.1 0.6-2.4 0.9-3.8 0.9-4.6 0-8.3-3.7-8.3-8.3z m15.7 3.8l-11.2-11.2c1.1-0.6 2.4-0.9 3.8-0.9 4.6 0 8.3 3.7 8.3 8.3 0 1.4-0.3 2.7-0.9 3.8z' })
        )
    );
};

exports.default = TiCancel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/cancel.js
// module id = 3023
// module chunks = 0